const APPCUES_ACCOUNT_ID = '122451';
const APPCUES_SRC = `https://fast.appcues.com/${APPCUES_ACCOUNT_ID}.js`;

let loadPromise = null;

function ensureAppcuesSettings() {
    if (window.AppcuesSettings) return;

    window.AppcuesSettings = {
        enableURLDetection: true,
        onError(error) {
            console.warn('Appcues error (non-critical):', error);
        },
    };
}

export function loadAppcues() {
    if (typeof window === 'undefined') {
        return Promise.resolve(null);
    }

    if (window.Appcues?.identify) {
        return Promise.resolve(window.Appcues);
    }

    if (loadPromise) {
        return loadPromise;
    }

    ensureAppcuesSettings();

    loadPromise = new Promise((resolve) => {
        const existing = document.querySelector(
            `script[src="${APPCUES_SRC}"]`
        );
        if (existing) {
            existing.addEventListener('load', () =>
                resolve(window.Appcues || null)
            );
            existing.addEventListener('error', () => {
                loadPromise = null;
                resolve(null);
            });
            return;
        }

        const script = document.createElement('script');
        script.src = APPCUES_SRC;
        script.defer = true;
        script.onerror = () => {
            console.warn('Appcues SDK failed to load');
            loadPromise = null;
            resolve(null);
        };
        script.onload = () => {
            resolve(window.Appcues || null);
        };
        document.head.appendChild(script);
    });

    return loadPromise;
}

export async function identifyAppcues(companyUid, properties) {
    const appcues = await loadAppcues();
    if (!appcues?.identify) return;

    try {
        appcues.identify(companyUid, properties);
    } catch (error) {
        console.warn('Appcues identify error (non-critical):', error);
    }
}
